module.exports = __webpack_public_path__ + "img/china_mobile_icon.a4795c53.svg";